export default theme => ({
  hexaText: {
    width: 200,
    height: 200,
    position: 'relative',
    strokeWidth: 1,
    stroke: theme.palette.grey.main,
    fill: theme.palette.common.white,
    color: theme.palette.grey.main,
    transition: 'color 0.3s, fill 0.3s, stroke 0.3s',
    '&:hover': {
      fill: theme.palette.grey.main,
      color: theme.palette.common.white,
    },
  },
  hexaTextContent: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    padding: '10% 10%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  hexaTextSvg: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});
